import {useAuth} from "../hooks/useAuth";
export type GridMode = "disabled" | "read-only" | "enabled";
export function useGridAccess(): GridMode {
  const {featureFlags} = useAuth();
  const mode = featureFlags.gridMode;
  if (mode === undefined) return "disabled";
  if (!["disabled", "read-only", "enabled"].includes(mode)) throw new Error("Invalid Grid capability");
  return mode;
}
